export default "__VITE_ASSET__DDF$HHYs__"